import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoFirefoxBrowser = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 134 51"
    {...props}
  >
    <path
      fill="url(#Logo_Firefox_Browser_svg__a)"
      d="M43.642 18.233c-.879-2.126-2.667-4.426-4.069-5.15a21.3 21.3 0 0 1 2.056 6.174v.037c-2.291-5.738-6.177-8.049-9.352-13.083a24 24 0 0 1-.476-.777 11 11 0 0 1-.225-.42 3.7 3.7 0 0 1-.303-.804c0-.026-.021-.047-.047-.052h-.037s-.005 0-.01.005-.01.005-.016.01v-.026c-5.084 2.993-6.81 8.532-6.972 11.304a10.15 10.15 0 0 0-5.58 2.157 7 7 0 0 0-.523-.399 9.5 9.5 0 0 1-.058-4.971c-1.872.908-3.53 2.2-4.88 3.785h-.01c-.805-1.024-.748-4.394-.7-5.098a3.3 3.3 0 0 0-.675.362c-.712.51-1.37 1.077-1.983 1.701a17.5 17.5 0 0 0-1.893 2.284 17.2 17.2 0 0 0-2.72 6.164l-.026.136q-.11.632-.199 1.27v.043a19.4 19.4 0 0 0-.33 2.803v.105c.011 11.24 9.096 20.339 20.289 20.334 9.858-.011 18.284-7.135 19.958-16.89.036-.262.063-.52.094-.787a21.04 21.04 0 0 0-1.313-10.222zM20.28 34.162c.094.047.183.094.283.136l.015.01a5 5 0 0 1-.293-.146z"
    />
    <path
      fill="url(#Logo_Firefox_Browser_svg__b)"
      d="M43.642 18.233c-.879-2.126-2.667-4.426-4.069-5.15a21.3 21.3 0 0 1 2.056 6.174v.042A18.5 18.5 0 0 1 41 33.033c-2.322 5.003-7.945 10.133-16.747 9.886-9.513-.273-17.892-7.36-19.456-16.637-.288-1.465 0-2.206.141-3.397a15.4 15.4 0 0 0-.324 2.808v.105c.01 11.24 9.095 20.339 20.288 20.334 9.858-.01 18.284-7.135 19.958-16.89.036-.262.063-.52.094-.787a21.04 21.04 0 0 0-1.313-10.222"
    />
    <path
      fill="url(#Logo_Firefox_Browser_svg__c)"
      d="M43.642 18.233c-.879-2.126-2.667-4.426-4.069-5.15a21.3 21.3 0 0 1 2.056 6.174v.042A18.5 18.5 0 0 1 41 33.033c-2.322 5.003-7.945 10.133-16.747 9.886-9.513-.273-17.892-7.36-19.456-16.637-.288-1.465 0-2.206.141-3.397a15.4 15.4 0 0 0-.324 2.808v.105c.01 11.24 9.095 20.339 20.288 20.334 9.858-.01 18.284-7.135 19.958-16.89.036-.262.063-.52.094-.787a21.04 21.04 0 0 0-1.313-10.222"
    />
    <path
      fill="url(#Logo_Firefox_Browser_svg__d)"
      d="m33.789 20.622.125.095a11 11 0 0 0-1.883-2.463c-6.297-6.326-1.647-13.718-.868-14.09v-.017c-5.084 2.993-6.81 8.532-6.972 11.304.236-.016.471-.037.712-.037a10.22 10.22 0 0 1 8.88 5.208z"
    />
    <path
      fill="url(#Logo_Firefox_Browser_svg__e)"
      d="M24.924 21.887c-.032.504-1.815 2.253-2.438 2.253-5.763 0-6.7 3.501-6.7 3.501.257 2.946 2.302 5.376 4.776 6.657.115.058.224.11.34.163.198.09.397.168.596.247.847.3 1.736.472 2.636.51 10.104.477 12.06-12.128 4.77-15.788 1.72-.225 3.462.2 4.89 1.192a10.23 10.23 0 0 0-8.88-5.208c-.242 0-.477.021-.712.037a10.15 10.15 0 0 0-5.58 2.158c.308.262.658.614 1.39 1.338 1.376 1.36 4.906 2.772 4.912 2.935z"
    />
    <path
      fill="url(#Logo_Firefox_Browser_svg__f)"
      d="M24.924 21.887c-.032.504-1.815 2.253-2.438 2.253-5.763 0-6.7 3.501-6.7 3.501.257 2.946 2.302 5.376 4.776 6.657.115.058.224.11.34.163.198.09.397.168.596.247.847.3 1.736.472 2.636.51 10.104.477 12.06-12.128 4.77-15.788 1.72-.225 3.462.2 4.89 1.192a10.23 10.23 0 0 0-8.88-5.208c-.242 0-.477.021-.712.037a10.15 10.15 0 0 0-5.58 2.158c.308.262.658.614 1.39 1.338 1.376 1.36 4.906 2.772 4.912 2.935z"
    />
    <path
      fill="url(#Logo_Firefox_Browser_svg__g)"
      d="M17.67 16.937q.212.134.418.278a9.5 9.5 0 0 1-.058-4.972c-1.872.908-3.53 2.2-4.88 3.785.1 0 3.04-.057 4.52.909"
    />
    <path
      fill="url(#Logo_Firefox_Browser_svg__h)"
      d="M4.798 26.282c1.564 9.277 9.943 16.364 19.45 16.632 8.803.252 14.425-4.877 16.748-9.886a18.52 18.52 0 0 0 .633-13.734v-.042.037c.721 4.714-1.664 9.277-5.398 12.364l-.01.026c-7.275 5.948-14.237 3.586-15.644 2.625a5 5 0 0 1-.293-.147c-4.241-2.037-5.993-5.911-5.617-9.24a5.2 5.2 0 0 1-4.801-3.035 7.62 7.62 0 0 1 7.453-.299 10.06 10.06 0 0 0 7.61.3c-.005-.163-3.536-1.575-4.911-2.935-.738-.73-1.083-1.076-1.392-1.339a7 7 0 0 0-.523-.399q-.208-.143-.418-.278c-1.48-.966-4.42-.914-4.519-.909h-.01c-.806-1.023-.748-4.394-.701-5.097a3.4 3.4 0 0 0-.675.362q-1.065.763-1.982 1.706a17.6 17.6 0 0 0-1.904 2.279 17.2 17.2 0 0 0-2.72 6.163c-.01.042-.732 3.203-.376 4.84z"
    />
    <path
      fill="url(#Logo_Firefox_Browser_svg__i)"
      d="M32.031 18.249a11 11 0 0 1 1.883 2.467q.156.119.303.252c4.598 4.253 2.187 10.264 2.009 10.694 3.734-3.087 6.119-7.654 5.403-12.369-2.291-5.738-6.177-8.053-9.352-13.088-.162-.257-.324-.514-.476-.777q-.116-.205-.225-.42a3.7 3.7 0 0 1-.303-.803c0-.026-.021-.047-.047-.053h-.037s-.005 0-.01.006c-.006.005-.01.005-.016.01-.785.373-5.434 7.765.868 14.086z"
    />
    <path
      fill="url(#Logo_Firefox_Browser_svg__j)"
      d="M34.217 20.969a5 5 0 0 0-.428-.347 6.98 6.98 0 0 0-4.89-1.192c7.29 3.66 5.334 16.26-4.77 15.787a9 9 0 0 1-2.637-.51 10 10 0 0 1-.936-.409l.016.01c1.407.967 8.368 3.324 15.643-2.624l.01-.027c.184-.425 2.59-6.436-2.008-10.689"
    />
    <path
      fill="url(#Logo_Firefox_Browser_svg__k)"
      d="M15.781 27.636s.937-3.501 6.7-3.501c.622 0 2.406-1.749 2.437-2.253-2.479.903-5.209.793-7.61-.299a7.62 7.62 0 0 0-7.452.3 5.21 5.21 0 0 0 4.8 3.034c-.376 3.328 1.376 7.203 5.618 9.24.094.047.183.094.282.136-2.474-1.28-4.518-3.711-4.775-6.657"
    />
    <path
      fill="url(#Logo_Firefox_Browser_svg__l)"
      d="M43.642 18.233c-.879-2.126-2.667-4.426-4.069-5.15a21.3 21.3 0 0 1 2.056 6.174v.037c-2.291-5.738-6.177-8.049-9.352-13.083a24 24 0 0 1-.476-.777 11 11 0 0 1-.225-.42 3.7 3.7 0 0 1-.303-.804c0-.026-.021-.047-.047-.052h-.037s-.005 0-.01.005-.01.005-.016.01v-.026c-5.084 2.993-6.81 8.532-6.972 11.304.236-.016.471-.037.712-.037a10.22 10.22 0 0 1 8.88 5.208 6.98 6.98 0 0 0-4.89-1.192c7.291 3.66 5.335 16.26-4.77 15.787a9 9 0 0 1-2.636-.51 10 10 0 0 1-.936-.409l.016.01a5 5 0 0 1-.293-.146c.094.047.183.094.282.136-2.474-1.286-4.518-3.712-4.775-6.657 0 0 .936-3.501 6.7-3.501.622 0 2.406-1.749 2.437-2.253-.005-.163-3.535-1.575-4.91-2.934-.738-.73-1.083-1.077-1.392-1.34a7 7 0 0 0-.523-.398 9.5 9.5 0 0 1-.058-4.972c-1.872.908-3.53 2.2-4.88 3.785h-.01c-.805-1.023-.748-4.394-.7-5.097a3.4 3.4 0 0 0-.675.362q-1.066.764-1.982 1.7a17.5 17.5 0 0 0-1.894 2.284 17.2 17.2 0 0 0-2.72 6.164l-.026.137c-.036.178-.209 1.086-.235 1.28 0-.015 0 .016 0 0q-.235 1.41-.298 2.835v.105c.01 11.24 9.095 20.339 20.288 20.334 9.858-.01 18.284-7.135 19.958-16.89.036-.262.063-.52.094-.787a21.04 21.04 0 0 0-1.313-10.222"
    />
    <path
      fill="#20123A"
      d="M54.667 16.747H65.87v3.04h-7.986v4.121h7.986v3.019h-7.986v6.63h-3.212v-16.81zm15.016-1.176a1.81 1.81 0 0 1 1.862 1.749v.141a1.873 1.873 0 0 1-1.846 1.9 1.873 1.873 0 0 1-1.894-1.852 1.863 1.863 0 0 1 1.789-1.933h.094zm-1.585 5.55h3.17v12.437h-3.17zm12.349 3.454a2.56 2.56 0 0 0-1.538-.551c-1.287 0-2.019.83-2.019 2.646v6.888h-3.143V21.126h3.007v1.795a2.95 2.95 0 0 1 2.96-1.91c.753 0 1.49.22 2.113.645l-1.375 2.924zm1.307 2.835c-.1-3.512 2.662-6.442 6.161-6.536h.22c3.718 0 6.36 2.646 6.36 6.331v1.313h-9.64c.346 1.564 1.564 2.604 3.421 2.604a3.32 3.32 0 0 0 3.075-1.843l2.642 1.59c-1.308 1.938-3.17 2.946-5.806 2.946-4.022 0-6.428-2.693-6.428-6.405zm3.143-1.407h6.522c-.345-1.59-1.632-2.462-3.305-2.462a3.19 3.19 0 0 0-3.217 2.462m10.377-4.882h2.228v-.625c0-3.386 1.423-4.788 4.545-4.788h1.103v2.74h-.894c-1.47 0-1.789.504-1.789 2.048v.625h2.683v2.856h-2.615v9.58h-3.033v-9.58h-2.228zm8.473 6.216c-.058-3.518 2.735-6.416 6.239-6.474h.236c3.561 0 6.448 2.893 6.448 6.468s-2.881 6.473-6.443 6.473h-.005c-3.452.127-6.35-2.577-6.475-6.042 0-.142-.005-.289 0-.43zm9.869 0a3.4 3.4 0 1 0-6.794-.236v.24a3.4 3.4 0 1 0 6.794.236zm7.343-.137-4.477-6.08h3.719l2.641 3.822 2.709-3.822h3.651l-4.545 6.054 4.775 6.379h-3.698l-2.96-4.053-2.871 4.053h-3.698z"
    />
    <defs>
      <radialGradient
        id="Logo_Firefox_Browser_svg__b"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(41.4594 0 0 42.3024 40.472 13.182)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0.13}
          stopColor="#FFBD4F"
        />
        <stop
          offset={0.28}
          stopColor="#FF980E"
        />
        <stop
          offset={0.47}
          stopColor="#FF3750"
        />
        <stop
          offset={0.78}
          stopColor="#EB0878"
        />
        <stop
          offset={0.86}
          stopColor="#E50080"
        />
      </radialGradient>
      <radialGradient
        id="Logo_Firefox_Browser_svg__c"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(42.4971 0 0 42.3024 24.581 26.43)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0.3}
          stopColor="#960E18"
        />
        <stop
          offset={0.35}
          stopColor="#B11927"
          stopOpacity={0.74}
        />
        <stop
          offset={0.43}
          stopColor="#DB293D"
          stopOpacity={0.34}
        />
        <stop
          offset={0.5}
          stopColor="#F5334B"
          stopOpacity={0.09}
        />
        <stop
          offset={0.53}
          stopColor="#FF3750"
          stopOpacity={0}
        />
      </radialGradient>
      <radialGradient
        id="Logo_Firefox_Browser_svg__d"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(13.6119 0 0 23.1892 28.618 3.37)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0.13}
          stopColor="#FFF44F"
        />
        <stop
          offset={0.53}
          stopColor="#FF980E"
        />
      </radialGradient>
      <radialGradient
        id="Logo_Firefox_Browser_svg__e"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(18.0073 0 0 19.8135 19.776 36.975)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0.35}
          stopColor="#3A8EE6"
        />
        <stop
          offset={0.67}
          stopColor="#9059FF"
        />
        <stop
          offset={1}
          stopColor="#C139E6"
        />
      </radialGradient>
      <radialGradient
        id="Logo_Firefox_Browser_svg__f"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(9.56281 0 0 11.69 23.983 21.72)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0.21}
          stopColor="#9059FF"
          stopOpacity={0}
        />
        <stop
          offset={0.97}
          stopColor="#6E008B"
          stopOpacity={0.6}
        />
      </radialGradient>
      <radialGradient
        id="Logo_Firefox_Browser_svg__g"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(14.318 0 0 14.4181 23.466 7.915)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0.1}
          stopColor="#FFE226"
        />
        <stop
          offset={0.79}
          stopColor="#FF7139"
        />
      </radialGradient>
      <radialGradient
        id="Logo_Firefox_Browser_svg__h"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(68.3284 0 0 57.5789 36.373 -1.673)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0.11}
          stopColor="#FFF44F"
        />
        <stop
          offset={0.46}
          stopColor="#FF980E"
        />
        <stop
          offset={0.72}
          stopColor="#FF3647"
        />
        <stop
          offset={0.9}
          stopColor="#E31587"
        />
      </radialGradient>
      <radialGradient
        id="Logo_Firefox_Browser_svg__i"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(4.73054 44.87777 -45.03838 4.74747 28.976 -9.728)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFF44F" />
        <stop
          offset={0.3}
          stopColor="#FF980E"
        />
        <stop
          offset={0.57}
          stopColor="#FF3647"
        />
        <stop
          offset={0.74}
          stopColor="#E31587"
        />
      </radialGradient>
      <radialGradient
        id="Logo_Firefox_Browser_svg__j"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(39.1729 0 0 38.5846 23.8 13.7)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0.14}
          stopColor="#FFF44F"
        />
        <stop
          offset={0.48}
          stopColor="#FF980E"
        />
        <stop
          offset={0.66}
          stopColor="#FF3647"
        />
        <stop
          offset={0.9}
          stopColor="#E31587"
        />
      </radialGradient>
      <radialGradient
        id="Logo_Firefox_Browser_svg__k"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(47.1464 0 0 42.3794 33.886 15.23)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0.09}
          stopColor="#FFF44F"
        />
        <stop
          offset={0.63}
          stopColor="#FF980E"
        />
      </radialGradient>
      <linearGradient
        id="Logo_Firefox_Browser_svg__a"
        x1={40.052}
        x2={7.326}
        y1={9.785}
        y2={41.348}
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0.05}
          stopColor="#FFF44F"
        />
        <stop
          offset={0.37}
          stopColor="#FF980E"
        />
        <stop
          offset={0.53}
          stopColor="#FF3647"
        />
        <stop
          offset={0.7}
          stopColor="#E31587"
        />
      </linearGradient>
      <linearGradient
        id="Logo_Firefox_Browser_svg__l"
        x1={38.028}
        x2={11.9}
        y1={10.205}
        y2={38.655}
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0.17}
          stopColor="#FFF44F"
          stopOpacity={0.8}
        />
        <stop
          offset={0.6}
          stopColor="#FFF44F"
          stopOpacity={0}
        />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgLogoFirefoxBrowser;
